import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled, { css } from 'styled-components';
import Input from '../atoms/Input';
import InputLabel from '../atoms/labels/InputLabel';
import ErrorLabel from '../atoms/labels/ErrorLabel';
import _ from 'lodash';
export const SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};
const OuterWrapper = styled.div `
    margin-bottom: 20px;
    margin-right: 20px;
    width: 100%;
    max-width: ${props => {
    if (props.size === SIZES.SMALL) {
        return '125px';
    }
    if (props.size === SIZES.MEDIUM) {
        return '190px';
    }
    if (props.size === SIZES.LARGE) {
        return '315px';
    }
    if (props.fullWidth) {
        return 'none';
    }
    return '480px';
}};

    &:last-child {
        margin-bottom: 0;
        margin-right: 0;
    }

    ${props => props.suffix &&
    css `
            position: relative;

            &:after {
                content: '${props.suffix}';
                position: absolute;
                top: 30px;
                right: 15px;
                font-weight: 600;
                font-size: 16px;
                color: ${props => props.theme.primary.base};
            }
        `}
`;
const StyledInputItem = styled.div `
    position: relative;
    display: flex;
    flex-direction: column;
`;
const IconWrapper = styled.div `
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
`;
const FocusBorder = styled.span `
    position: absolute;
    bottom: 0;
    left: 0;
    transform-origin: 0;
    transform: scaleX(0);
    width: 100%;
    height: 1px;
    background-color: ${props => props.theme.secondary};
    transition: all 300ms ease-in-out;
    border-radius: 1px;
`;
const InputItem = ({ className, icon, label, error, fullWidth, size, suffix, ...props }) => {
    const [fid] = useState(() => props.id || _.uniqueId('field-'));
    return (_jsxs(OuterWrapper, { fullWidth: fullWidth, size: size, suffix: suffix, className: className, children: [_jsxs(StyledInputItem, { children: [icon && _jsx(IconWrapper, { children: icon }), _jsx(InputLabel, { htmlFor: fid, required: props.required, children: label }), _jsx(Input, { ...props, id: fid }), _jsx(FocusBorder, { className: "focus-border" })] }), error && _jsx(ErrorLabel, { children: error })] }));
};
export default InputItem;
